// src/pages/usa/colorado/ManitouSprings.js
import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";
import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

// ⭐ STRICT COMMAND: Manitou Springs ALWAYS goes back to Colorado map
export const backRoute = "/map/colorado";

export default function ManitouSprings() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__manitouSpringsBackRouteSet) {
      window.__manitouSpringsBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (

    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Manitou Springs, Colorado</h1>

        <section className="travel-review">
          {/* LEFT COLUMN — TEXT */}
          <div className="travel-text">
            <h2>🏞️ Discover Manitou Springs, Colorado</h2>

            <p>
              <strong>Manitou Springs</strong> is a small, artsy community nestled at the base of Pikes Peak,
              often mistaken as part of Colorado Springs. Known for its mineral springs, quirky shops, and the
              famous <strong>Manitou Incline</strong>, this town blends seamlessly into the local experience
              and deserves its own spotlight.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
              The drive from Denver to Manitou Springs takes about 1.5 hours via I‑25 South. As you approach the
              area, Pikes Peak rises dramatically in the distance. For air travel, you can fly into
              <strong> Denver International Airport (DEN)</strong> or the more convenient
              <strong> Colorado Springs Airport (COS)</strong>, located just 20 minutes away.
            </p>

            <h3>🌟 My Personal Observation</h3>

<ul>
  <li>
  <div className="place-block">
    <strong>The Incline:</strong> This beast is one of the most famous challenges in all of Colorado. With a length of about 
    <strong> 0.88 miles</strong>, an elevation gain of roughly <strong>2,000 feet</strong>, and 
    <strong> 2,744 steps</strong>, the Manitou Incline climbs at brutal grades ranging from 
    <strong> 30% to nearly 70%</strong>. It has become a magnet for fitness enthusiasts, athletes, and anyone looking to test their limits.
    <br /><br />
    Over the years, the Incline has collected some wild records — including the 
    <strong> fastest ascent at 17 minutes 25 seconds</strong>, and extreme athletes completing 
    <strong> over 20 laps in a single day</strong>. What makes it even more fascinating is its history: these “steps” were originally built in 
    <strong> 1907</strong> as part of a <strong>cable car railway</strong> used to haul materials up Pikes Peak. After a rockslide destroyed the tracks in 1990, locals began hiking the exposed railroad ties, and the trail eventually became the legendary challenge it is today.
    <br /><br />
    If you feel adventurous — and brave enough — to take on this climb, make sure you’re physically prepared. Bring 
    <strong> water</strong>, <strong>snacks</strong>, and take your time. The trail is steep, the altitude is real, and wildlife is part of the experience. But once you reach the top, the views and the sense of accomplishment are absolutely worth it.
    <br />
    <a
      href="https://www.google.com/maps?q=38.857001842666996,-104.93275119943685"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 View on Google Maps
    </a>
  </div>
</li>

 <li>
  <div className="place-block">
    <strong>Cave of the Winds:</strong> Discovered in <strong>1881</strong> by two teenage brothers exploring Williams Canyon,
     Cave of the Winds got its name when they felt <strong>cold air blasting out of a crack in the rock</strong> — that sudden “wind”
     revealed the entrance to one of Colorado’s most fascinating underground worlds. This <strong>massive underground cave
     system</strong> sits tucked into Williams Canyon right above Manitou Springs. The caves are famous for their <strong>rare
     formations</strong>, <strong>deep chambers</strong>, <strong>narrow passageways</strong>, <strong>dramatic 
     lighting</strong>, <strong>adventure tours</strong>, and even <strong>cliffside attractions</strong> perched high above the canyon.
     This isn’t just a cave — <strong>it’s a full experience</strong>, blending geology, history, adrenaline, and scenery into one unforgettable attraction.
    <br />
    <a
      href="https://www.google.com/maps?q=38.87250826675426, -104.92018484123712"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 View on Google Maps
    </a>
  </div>
</li>


<li>
  <div className="place-block">
    <strong>Rainbow Falls:</strong> Rainbow Falls gets its name from the colorful graffiti that once covered the canyon walls and the historic bridge above the waterfall — creating bright splashes of color that looked like a rainbow surrounding the cascade. The area has since been restored, but the name remains part of its identity. The falls sit beneath a 1930s highway bridge and are typically open to the public during the warmer months, usually from late spring through early fall. It’s a short, easy walk from the parking area, making it one of the most accessible and photogenic waterfalls near Manitou Springs.
    <br />
    <a
      href="https://www.google.com/maps?q=38.870192120247204, -104.92589808432474"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Rainbow Falls
    </a>
  </div>
</li>


  <li>
  <div className="place-block">
    <strong>Manitou Cliff Dwellings:</strong> These structures, similar in style to the ones at Mesa
     Verde, were originally built by the <strong> Ancestral Puebloans</strong> — the same culture associated
      with Mesa Verde. But they were <strong> not originally located in Manitou Springs</strong>. Instead, the
       dwellings were <strong> dismantled, transported, and carefully reassembled</strong> here between <strong>1904 and 1907</strong>. They were moved because the original site in southwestern Colorado was being 
    <strong> looted and vandalized</strong> in the early 1900s. Relocating them to Manitou Springs provided a 
    <strong> safer and more accessible location</strong>, allowing the structures to be preserved and shared with the public.
    <br />
    <a
      href="https://www.google.com/maps?q=38.86306623145938, -104.91243214725561"
      target="_blank"
      rel="noopener noreferrer"
    >
      📍 Manitou Cliff Dwellings
    </a>
  </div>
</li>

</ul>

{/* 🥾 HIDDEN GEMS */}
<h3>🥾 Hidden Gems in Manitou Springs</h3>

<ul>
  <li>
    <div className="place-block">
      <strong>Pikes Peak Cog Railway Station:</strong> The historic depot where the famous train begins its climb to the summit of Pikes Peak.
      <br />
      <a
        href="https://www.google.com/maps?q=38.856060796701456, -104.93141052291531"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 Cog Railway Station
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Downtown Manitou Springs:</strong> A walkable, artsy district filled with boutiques, cafés, galleries, and mountain‑town charm.
      <br />
      <a
        href="https://www.google.com/maps?q=38.8576,-104.9172"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 Downtown Manitou Springs
      </a>
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Penny Arcade:</strong> A nostalgic arcade with vintage machines, pinball, and classic games — a local favorite.
      <br />
      <a
        href="https://www.google.com/maps?q=38.85891176267169, -104.9176540327969"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 Penny Arcade
      </a>
    </div>
  </li>


  <li>
    <div className="place-block">
      <strong>Miramont Castle Museum:</strong> A Victorian mansion with architecture, artifacts, and beautiful hillside views.
      <br />
      <a
        href="https://www.google.com/maps?q=38.859290953910985, -104.92247271745211"
        target="_blank"
        rel="noopener noreferrer"
      >
        📍 Miramont Castle
      </a>
    </div>
  </li>
</ul>

           {/* 🛏️ PLACES TO STAY */}
<h3>🛏️ Places to Stay in Manitou Springs and Nearby</h3>

<ul>
  <li>
    <div className="place-block">
      <strong>Cliff House at Pikes Peak:</strong> Rated 9.2/10 on U.S. News Travel — a historic Victorian hotel located right in downtown Manitou Springs.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Magnuson Grand Pikes Peak:</strong> Rated 8.6/10 on Expedia — close to Manitou with mountain views and an indoor pool.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Eagle Motel:</strong> Rated 8.4/10 on Booking.com — a clean, locally‑owned option right in Manitou Springs.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Garden of the Gods Resort and Club:</strong> Rated 9.4/10 on Expedia — luxury stay with stunning red‑rock views, just minutes from Manitou.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>Best Western Plus Executive Residency Fillmore Inn:</strong> Rated 9.0/10 on Expedia — modern, comfortable, and close to Garden of the Gods.
    </div>
  </li>

  <li>
    <div className="place-block">
      <strong>SCP Hotel Colorado Springs:</strong> Rated 8.8/10 on Booking.com — eco‑friendly, stylish, and a short drive to Manitou Springs.
    </div>
  </li>
</ul>


            {/* AFFILIATE BLOCK */}
           <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                       <div className="affiliate-block">
                         <AffiliateExpedia />
                         <AffiliateBooking />
                         <AffiliateTrip />
                       </div>

            {/* 🎥 VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>Here are some videos from Manitou Springs and Colorado Springs:</p>

            <p>
              <a
                href="https://youtu.be/LUBk4WOOvkc?si=0ZSGMxY09MCkXBxl"
                target="_blank"
                rel="noopener noreferrer"
              >
                The Incline
              </a>
              <br />
              <a
                href="https://youtu.be/x7p5CwpTtxg?si=mc8aGqzgJxq_od1b"
                target="_blank"
                rel="noopener noreferrer"
              >
                Pikes Peak
              </a>
            </p>
          </div>

          {/* RIGHT COLUMN — IMAGES */}
          <div className="travel-image-column">
            <a
              href="https://youtu.be/LUBk4WOOvkc?si=0ZSGMxY09MCkXBxl"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/manitousprings/theincline.jpg"
                alt="The Incline Video"
              />
            </a>

            <a
              href="https://youtu.be/x7p5CwpTtxg?si=mc8aGqzgJxq_od1b"
              target="_blank"
              rel="noopener noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/coloradosprings/train.jpg"
                alt="Pikes Peak Video"
              />
            </a>

            
        
            <img src="/images/usa/colorado/manitousprings/mt1.jpg" alt="Manitou Buildings" />
            <img src="/images/usa/colorado/manitousprings/mt2.jpg" alt="Manitou Buildings" />
            <img src="/images/usa/colorado/manitousprings/mt3.jpg" alt="Manitou Buildings" />
            <img src="/images/usa/colorado/manitousprings/mt4.jpg" alt="Manitou Buildings" />
            <img src="/images/usa/colorado/manitousprings/mt5.jpg" alt="Manitou Buildings" />
            <img src="/images/usa/colorado/manitousprings/dw1.jpg" alt="Manitou Buildings" />
            <img src="/images/usa/colorado/manitousprings/dw2.jpg" alt="Manitou Buildings" />
            <img src="/images/usa/colorado/manitousprings/dw3.jpg" alt="Manitou Buildings" />
            <img src="/images/usa/colorado/manitousprings/dw4.jpg" alt="Manitou Buildings" />
            <img src="/images/usa/colorado/manitousprings/cow.jpg" alt="Manitou Buildings" />
             <img src="/images/usa/colorado/manitousprings/cow2.jpg" alt="Manitou Buildings" />
              <img src="/images/usa/colorado/manitousprings/cow3.jpg" alt="Manitou Buildings" />
            
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
